module.exports = __webpack_public_path__ + "media/icons/linkedin-white-3012392b.png";